import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getArticles, getUploadUrl } from '../services/api';
import useFadeIn from '../hooks/useFadeIn';
// import logo from '../assets/logo.png';
import '../css/sections.css';


/* ── Unified cover-story people: the hero card cycles through this
   list automatically, and the thumbnail strip below is built from
   the same list — the active thumb (matching the current hero)
   gets a gold highlight. ── */
const COVER_PEOPLE = [
    {
  _id: 'AI_Virtual',
  // name: 'Jennifer',
  // surname: 'White',
  // role: 'The Most Influential Healthcare Advocate & Author to Watch in 2026',
  imageUrl: 'https://xenogeneic-turquoise-isfetp2h.edgeone.dev/Hamid%20kohan%20artical.png',
},
  {
  _id: 'Jennifer_White',
  // name: 'Jennifer',
  // surname: 'White',
  // role: 'The Most Influential Healthcare Advocate & Author to Watch in 2026',
  imageUrl: 'https://architectural-amber-bycffsc3.edgeone.dev/MueyxfnCSE.png',
},

  {
  _id: 'Dana_Hatch',
  // name: 'Dana',
  // surname: 'Hatch',
  role: 'Founder of The Unfiltered Method',
  // company: 'The Unfiltered Method × Aesthetic Ascend',
  // kicker: 'Cover Story',
  // award: '2026',
  // awardPill: 'Founder',
  // awardSub: 'The Ones to Watch',
  imageUrl: 'https://ordinary-amber-smigi1lm.edgeone.dev/file.png',
},
  {
    _id: 'p1',
    // name: 'Antonia J.A.',
    // surname: 'Hock',
    role: 'Global Luxury Customer Experience Architect',
    // company: 'Luxury Customer Experience',
    // kicker: 'Most',
    // award: 'Influential',
    // awardPill: 'Luxury Business Leader',
    // awardSub: 'To Watch In 2026',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Antonia%20J.A.%20Hock.png',
  },
  {
    _id: 'p2',
    // name: 'Hande',
    // surname: 'Kizir',
    role: 'Global IT Recruitment Leader',
    // company: 'IT Recruitment',
    // kicker: 'Most',
    // award: 'Influential',
    // awardPill: 'HR & Recruitment Leader',
    // awardSub: 'To Watch In 2026',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Hande%20Kizir.png',
  },
  {
    _id: 'p3',
    // name: 'Dr. Nazli',
    // surname: 'Azimi',
    role: 'Co-founder & CEO',
    // company: 'Thena Biosciences',
    // kicker: 'Most',
    // award: 'Visionary',
    // awardPill: 'Biotech Entrepreneur',
    // awardSub: 'To Watch In 2026',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Dr.%20Nazli%20Azimi.png',
  },
  {
    _id: 'p4',
    // name: 'María Teresa',
    // surname: 'Salazar de García',
    role: 'Corporate Governance Leader',
    // company: 'Global Corporate Governance',
    // kicker: 'Most',
    // award: 'Visionary',
    // awardPill: 'Governance Leader',
    // awardSub: 'To Watch In 2026',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Mar%C3%ADa%20Teresa%20Salazar%20de%20Garc%C3%ADa.png',
  },
  {
    _id: 'p5',
    // name: 'Alice',
    // surname: 'Shikina',
    role: 'Conflict Resolution & Negotiation Expert',
    // company: 'Leadership & Communication',
    // kicker: 'Hall of Fame',
    // award: '2026',
    // awardPill: 'Public Speaker',
    // awardSub: 'The Ones Who Made It',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Alice%20Shikina.png',
  },
// {
//   id: 'p8',
//   // name: 'Paul ',
//   // surname: 'Bray',
//   role: 'Director: Consultancy & Training',
//   // company: 'SEND International',
//   // kicker: 'Confidence Through Challenges',
//   // award: 'Perspective and Solutions for Mental Health Advocacy in Education',
//   // awardPill: '',
//   // awardSub: '',
//   imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Paul%20Bray.png',
// },
// {
// id: 'p7',
// // name: 'Diotec',
// // surname: '',
// role: 'Top 10 Semiconductor Companies',
// // company: '',
// // kicker: 'The Diotec Semiconductor Story',
// // award: '',
// // awardPill: '',
// // awardSub: '',
// imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Diotec%20Semiconductor%20AG.png', 
// },


];

const CXO_ARTICLES = [
  {
    _id: 'f1',
    accent: 'gold',
    tag: 'Confidence Through Challenges',
    title: 'Confidence Through Challenges: Perspective and Solutions for Mental Health Advocacy in Education',
    name: 'Paul Bray',
    role: 'Director: Consultancy & Training, SEND International',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Paul%20Bray.png',
  },
  {
    _id: 'f2',
    accent: 'red',
    tag: 'Top 10 Semiconductor Companies',
    title: 'The Diotec Semiconductor Story',
    name: 'Diotec',
    role: 'Semiconductor Manufacturer',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Diotec%20Semiconductor%20AG.png',
  },
  {
    _id: 'c1',
    accent: 'gold',
    tag: 'Biotech Entrepreneurs to Know!',
    title: 'Nazli Azimi: Charting the Future of Medicine with Science, Courage, and Care',
    name: 'Nazli Azimi',
    role: 'Biotech Entrepreneurs to Know!',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Dr.%20Nazli%20Azimi.png',
  },
  {
    _id: 'c2',
    accent: 'red',
    tag: ' Conflict Resolution & Negotiation Expert',
    title: 'Alice Shikina: The Peacemaker Who Turned Conflict into a Calling',
    name: 'Alice Shikina',
    role: 'The Ones Who Made It',
    imageUrl: 'https://alive-jade-wxemzyzg.edgeone.dev/Alice%20Shikina.png',
  },
];

function CxoCard({ item }) {
  return (
    <Link to={`/article/${item._id}`} className={`cxo-card cxo-accent-${item.accent} fade-in`}>
      <div className="cxo-card-photo">
        <img src={getUploadUrl(item.imageUrl)} alt={item.name} loading="lazy" width="1536" height="1024" />
        {/* <span className="cxo-card-tag">{item.tag}</span> */}
      </div>
      <div className="cxo-card-body">
        <h3 className="cxo-card-title">{item.title}</h3>
        <p className="cxo-card-person">
          <strong>{item.name}</strong>
          <span>{item.role}</span>
        </p>
      </div>
    </Link>
  );
}

/* Merge API data over a COVER_PEOPLE-shaped default, so a partial
   API response never renders blank. */
function mergeWithFallback(apiItem, fallback) {
  if (!apiItem) return fallback;
  const merged = { ...fallback };
  Object.keys(fallback).forEach((key) => {
    const val = apiItem[key];
    if (val !== undefined && val !== null && val !== '') merged[key] = val;
  });
  return merged;
}

const ROTATE_MS = 2500; // hero + thumbs advance together every 2.5s

export default function CoverStories() {
  const [people, setPeople] = useState(COVER_PEOPLE);
  const [activeIndex, setActiveIndex] = useState(0);
  const ref = useFadeIn(true);

  useEffect(() => {
    getArticles({ coverStory: true, limit: 10 })
      .then((r) => {
        const data = r.data?.data;
        if (data?.length) {
          setPeople(
            data.slice(0, 6).map((item, i) => mergeWithFallback(item, COVER_PEOPLE[i % COVER_PEOPLE.length]))
          );
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (people.length < 2) return;
    const id = setInterval(() => setActiveIndex((i) => (i + 1) % people.length), ROTATE_MS);
    return () => clearInterval(id);
  }, [people.length]);

  const hero = people[activeIndex] || people[0];
  const heroId = hero._id || hero.id;
  const fullName = `${hero.name || ''} ${hero.surname || ''}`.trim();

  return (
    <section className="sec sec-dark cover-stories-sec" id="cover-stories" ref={ref}>
      <div className="wrap cs-layout">

        {/* ── Left: featured cover story (landscape card) ── */}
        <div className="cs-left">
          <h2 className="cs-label fade-in">Cover Story</h2>

          <Link to={`/article/${heroId}`} className="cs-hero fade-in">
            <div className="cs-hero-photo" key={heroId}>
              <img src={getUploadUrl(hero.imageUrl)} alt={fullName} loading="lazy" width="1536" height="1024" />
            </div>

            <div className="cs-hero-body" key={`body-${heroId}`}>
              {(hero.kicker || hero.awardPill) && (
                <div className="cs-hero-chips ">
                  {hero.kicker && <span className="cs-hero-kicker">{hero.kicker}</span>}
                  {hero.awardPill && <span className="cs-hero-pill">{hero.awardPill}</span>}
                </div>
              )}

              {fullName && <h3 className="cs-hero-name">{fullName}</h3>}

              {(hero.role || hero.company) && (
                <p className="cs-hero-role cxo-card-tag">
                  {hero.role}
                  {hero.role && hero.company && ' | '}
                  {hero.company && <strong>{hero.company}</strong>}
                </p>
              )}
            </div>
          </Link>

          <div className="cs-dots" aria-hidden="true">
            {people.map((p, i) => (
              <button
                type="button"
                key={`dot-${p._id || p.id}-${i}`}
                className={`cs-dot ${i === activeIndex ? 'is-active' : ''}`}
                onClick={() => setActiveIndex(i)}
                tabIndex={-1}
              />
            ))}
          </div>

          <div className="cs-thumbs-wrap fade-in" aria-label="More cover stories">
            <div
              className="cs-thumbs-track"
              style={{ animationDuration: `${people.length * (ROTATE_MS / 1000)}s` }}
            >
              {[...people, ...people].map((p, i) => (
                <Link
                  to={`/article/${p._id || p.id}`}
                  className={`cs-thumb ${i % people.length === activeIndex ? 'is-active' : ''}`}
                  key={`${p._id || p.id}-${i}`}
                >
                  <img src={getUploadUrl(p.imageUrl)} alt={`${p.name} ${p.surname}`} loading="lazy" width="1536" height="1024" />
                  <span className="cs-thumb-name">{p.name} {p.surname}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* ── Right: CXO articles (landscape cards) ── */}
        <div className="cs-right">
          <h2 className="cs-label fade-in">CXO Articles</h2>
          <div className="cxo-grid">
            {CXO_ARTICLES.map((item) => <CxoCard key={item._id} item={item} />)}
          </div>
        </div>

      </div>
    </section>
  );
}